import Swiper from 'swiper'
import {Navigation, Pagination} from 'swiper/modules'

const doorwaysSliders =
    document.querySelectorAll<HTMLElement>('.doorways-slider')

doorwaysSliders.forEach((doorwaysSlider) => {
    new Swiper(doorwaysSlider, {
        modules: [Navigation, Pagination],
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 16,
        breakpoints: {
            448: {
                slidesPerView: 1.15,
            },
            1280: {
                slidesPerView: 2,
                centeredSlides: false,
                spaceBetween: 8,
            },
        },
    })
})
